module.exports = __webpack_public_path__ + "static/img/s17.1b068b70.png";